export const codeActive1 = `
import { motion } from 'framer-motion'

const [isActive, setIsActive] = useState(false);

//handle your state
const toggleActive = () => {
    setIsActive(!isActive);
};

<motion.div
    onClick={toggleActive}
    animate={{
        scale: isActive ? 1 : 0.5,
        backgroundColor: isActive ? "#2ecc71" : "#3498db",
    }}
    transition={{ type: "spring", stiffness: 300 }}
>
    {isActive ? "Active" : "Inactive"}
</motion.div>

`

export const codeActive2 = `
import { motion } from 'framer-motion'

const [activeIndex, setActiveIndex] = useState(0);

<nav className="relative">
    <ul className="flex space-x-6">
        {navItems.map((item, index) => (
            <motion.li
                key={index}
                onClick={() => setActiveIndex(index)}
                className={\`cursor-pointer transition-all duration-300 pb-2 relative \${activeIndex === index ? 'text-[#d7f93e]' : 'text-[#FFF]'}\`}
            >
                {item}
                {activeIndex === index && (
                    <div
                        layoutId="underline"
                        className="absolute transition-all duration-300 left-0 right-0 h-[2px] bg-blue-500 bottom-0"
                    />
                )}
            </motion.li>
        ))}
    </ul>
</nav>
`

export const codeActive3 = `
import { motion } from 'framer-motion'

const [activeIndex, setActiveIndex] = useState(0);


<nav className="relative">
    <ul className="flex space-x-6">
        {navItems.map((item, index) => (
            <motion.li
                animate={{ color: activeIndex === index ? '#d7f93e' : '#FFF' }}
                key={index}
                onClick={() => setActiveIndex(index)}
                className='cursor-pointer pb-2 relative'
            >
                {item}
                {activeIndex === index && (
                    <motion.div
                        layoutId="underline"
                        className="absolute left-0 right-0 h-[2px] bg-blue-500 bottom-0"
                        transition={{ duration: 0.3 }}
                    />
                )}
            </motion.li>
        ))}
    </ul>
</nav>
`


export const ExampleJs = `
import * as React from "react";
import { useRef } from "react";
import { motion, useCycle } from "framer-motion";
import { MenuToggle } from "./MenuToggle";
import "./style.css";
import { Navigation } from "./Navigation";

const sidebar = {
    open: (height = 1000) => ({
        clipPath: \`circle(\${height * 2 + 200}px at 40px 40px)\`,
        transition: {
            type: "spring",
            stiffness: 20,
            restDelta: 2
        }
    }),
    closed: {
        clipPath: "circle(30px at 40px 40px)",
        transition: {
            delay: 0.5,
            type: "spring",
            stiffness: 400,
            damping: 40
        }
    }
};

export const Example = () => {
    const [isOpen, toggleOpen] = useCycle(false, true);
    const containerRef = useRef(null);

    const useDimensions = ref => {
        const dimensions = useRef({ width: 0, height: 0 });

        React.useEffect(() => {
            dimensions.current.width = ref.current.offsetWidth;
            dimensions.current.height = ref.current.offsetHeight;
        }, []);

        return dimensions.current;
    };

    const { height } = useDimensions(containerRef);

    return (
        <motion.nav
            initial={false}
            animate={isOpen ? "open" : "closed"}
            custom={height}
            ref={containerRef}
        >
            <motion.div className="background" variants={sidebar} />
            <Navigation />
            <MenuToggle toggle={() => toggleOpen()} />
        </motion.nav>
    );
};
`

export const MenuItemJs = `
import * as React from "react";
import { motion } from "framer-motion";

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};

const colors = ["#FF008C", "#D309E1", "#9C1AFF", "#7700FF", "#4400FF"];

export const MenuItem = ({ i }) => {
  const style = { border: \`2px solid \${colors[i]}\` };
  return (
    <motion.li
      variants={variants}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="icon-placeholder md:bg-red-50" style={style} />
      <div className="text-placeholder" style={style} />
    </motion.li>
  );
};

`

export const NavigationJs = `
import * as React from "react";
import { motion } from "framer-motion";
import { MenuItem } from "./MenuItem";

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
};

export const Navigation = () => (
  <motion.ul variants={variants}>
    {itemIds.map(i => (
      <MenuItem i={i} key={i} />
    ))}
  </motion.ul>
);

const itemIds = [0, 1, 2, 3, 4];

`

export const MenuToggleJs = `
import * as React from "react";
import { motion } from "framer-motion";

const Path = props => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    stroke="hsl(0, 0%, 18%)"
    strokeLinecap="round"
    {...props}
  />
);

export const MenuToggle = ({ toggle }) => (
  <button onClick={toggle} className="text-white flex items-center justify-center">
    <svg width="23" height="23" viewBox="0 0 23 23">
      <Path
        variants={{
          closed: { d: "M 2 2.5 L 20 2.5" },
          open: { d: "M 3 16.5 L 17 2.5" }
        }}
      />
      <Path
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 }
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: "M 2 16.346 L 20 16.346" },
          open: { d: "M 3 2.5 L 17 16.346" }
        }}
      />
    </svg>
  </button>
);

`

export const styleCss = `
nav {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 300px;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 300px;
  background: #fff;
}

button {
  outline: none;
  border: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: pointer;
  position: absolute;
  top: 18px;
  left: 15px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: transparent;
}

ul,
li {
  margin: 0;
  padding: 0;
}

ul {
  padding: 25px;
  position: absolute;
  top: 100px;
  width: 230px;
}

li {
  list-style: none;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.icon-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex: 40px 0;
  margin-right: 20px;
}

.text-placeholder {
  border-radius: 5px;
  width: 200px;
  height: 20px;
  flex: 1;
}

.refresh {
  padding: 10px;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  width: 20px;
  height: 20px;
  top: 10px;
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
`